export const tr = {
    all: 'Hepsi',
    'find-platforms': 'Platformları bul',
    format: 'Format',
    operator: 'Operatör',
    selected: 'Seçilenler'
};
